import adjustEvents from '../json/adjust-events.json';

const IMPACT_CLICK_ID = 'irclickid';

let eventMetaData = {
	client: 'web'
};

function getAnalyticsOptions(eventName, originalContext = {}) {
	const integrations = {
		Iterable: false,
		Optimizely: window.optimizelyEvents ? window.optimizelyEvents.includes(eventName) : null
	};

	const options = { integrations, context: originalContext };
	const urlParams = new URLSearchParams(window.location.search);

	if (urlParams.has(IMPACT_CLICK_ID)) {
		const clickId = urlParams.get(IMPACT_CLICK_ID);
		const context = {
			...originalContext,
			referrer: {
				type: 'impactRadius',
				id: clickId,
			},
		};
		options.context = context;
	}

	return options;
}

function identify(id) {
	var date = new Date();
	var timezoneArray = /\((.*)\)/.exec(date.toString());
	var timezone = (timezoneArray && timezoneArray.length > 1) ? timezoneArray[1] : null;
	var urlParams = new URLSearchParams(window.location.search);
	var properties = {
		app: 'Growth',
		release: VERSION,
		visit_date_and_time: date.toString(),
		visit_hour: date.getHours(),
		time_zone: timezone,
		label: null,
		category: null,
		user_id: id
	};

	if (urlParams.has('utm_source') && urlParams.has('utm_medium')) {
		// Check mixpanel cookie to see if utms have already been defined
		const decodedCookie = decodeURIComponent(document.cookie);
		const mpCookie = decodedCookie.split('; ').find(cookie => cookie.includes('mp_'));
		let parsedMpCookie;

		if (mpCookie) parsedMpCookie = JSON.parse(mpCookie.split('=')[1]);

		if (!mpCookie || !parsedMpCookie.utm_medium) properties.utm_medium = urlParams.get('utm_medium');
		if (!mpCookie || !parsedMpCookie.utm_source) properties.utm_source = urlParams.get('utm_source');
		if (!mpCookie || !parsedMpCookie.utm_term) properties.utm_term = urlParams.get('utm_term');
		if (!mpCookie || !parsedMpCookie.utm_campaign) properties.utm_campaign = urlParams.get('utm_campaign');
		if (!mpCookie || !parsedMpCookie.utm_content) properties.utm_content = urlParams.get('utm_content');
	}

	window.analytics.identify(id, properties, getAnalyticsOptions());
}

function track(event, properties, callback, context = {}) {
	if (window.analytics && typeof window.analytics.track === 'function') {
		var adjustLoaded = typeof window.Adjust === 'object' ? true : false;
		var adblockerMessaging = adjustLoaded ? 'Potential Ad Blocker' : '';
		var adjustAttribution = window.Adjust.getAttribution();
		var adjustAdid = adjustAttribution ? adjustAttribution.adid : `Adjust adid not available. ${adblockerMessaging}`;
		var adjustWebUUID = window.Adjust.getWebUUID() ? window.Adjust.getWebUUID() : `Adjust web_uuid not available. ${adblockerMessaging}`;


		properties = Object.assign({}, eventMetaData, properties);
		properties.adjust_adid = adjustAdid;
		properties.adjust_web_uuid = adjustWebUUID;
		properties.adjust_loaded = adjustLoaded;
		properties.web_build_version = document.getElementById('build').value;

		window.analytics.track(event, properties, getAnalyticsOptions(event, context), callback);
	}

	trackAdjustEvent(event);
}

function trackAdjustEvent(event, email, userId, currency, transactionValue) {
	const adjustEventName = event.replace(/\s-\s|\s/g, '-').toLowerCase();
	const eventToken = adjustEvents[adjustEventName];

	if (typeof window.Adjust !== 'object' && typeof window.Adjust.trackEvent !== 'function' || !eventToken) return;

	if (transactionValue) {
		window.Adjust.addGlobalCallbackParameters([
			{ key: 'currency', value: currency },
			{ key: 'transaction_value', value: transactionValue }
		]);
	} else if (email && userId) {
		window.Adjust.addGlobalCallbackParameters([
			{ key: 'email', value: email },
			{ key: 'user_id', value: userId }
		]);
	}

	if (currency) {
		window.Adjust.trackEvent({
			eventToken,
			currency
		});
	} else {
		window.Adjust.trackEvent({ eventToken });
	}
}

function trackSuccessfulRegistration(optimizelyId, properties, email, userId, callback, context) {
	if (window.analytics && typeof window.analytics.track === 'function') {
		var event = 'Account Registration - Successful';
		var adjustLoaded = typeof window.Adjust === 'object' ? true : false;
		var adblockerMessaging = adjustLoaded ? 'Potential Ad Blocker' : '';
		var adjustAttribution = window.Adjust.getAttribution();
		var adjustAdid = adjustAttribution ? adjustAttribution.adid : `Adjust adid not available. ${adblockerMessaging}`;
		var adjustWebUUID = window.Adjust.getWebUUID() ? window.Adjust.getWebUUID() : `Adjust web_uuid not available. ${adblockerMessaging}`;

		properties = Object.assign({}, eventMetaData, properties);
		properties.adjust_adid = adjustAdid;
		properties.adjust_web_uuid = adjustWebUUID;
		properties.adjust_loaded = adjustLoaded;
		properties.web_build_version = document.getElementById('build').value;

		if (optimizelyId && window.optimizelyClientInstance && typeof window.optimizelyClientInstance.track === 'function') {
			window.optimizelyClientInstance.track(event, optimizelyId, {}, properties);
		}

		window.analytics.track(event, properties, getAnalyticsOptions(event, context), callback);
		trackAdjustEvent(event, email, userId);
	}

	// Track account creation via Live Intent Pixel
	window.liQ = window.liQ || [];
	window.liQ.push({
		event: 'signup',
		email: email,
		conversionId: userId,
	});

	// Track account creation via Bing Ads
	window.uetq = window.uetq || [];
	window.uetq.push('event', 'Account Registration', {
		'event_category': 'sign up',
		'event_label': 'successful submission'
	});

	// Track account creation via Pinterest Tag
	pintrk('track', 'Signup');
}

function trackSuccessfulTrialSignup(optimizelyId, properties, callback) {
	if (window.analytics && typeof window.analytics.track === 'function') {
		var event = 'Web Account Registration - Trial Activated';
		var adjustLoaded = typeof window.Adjust === 'object' ? true : false;
		var adblockerMessaging = adjustLoaded ? 'Potential Ad Blocker' : '';
		var adjustAttribution = window.Adjust.getAttribution();
		var adjustAdid = adjustAttribution ? adjustAttribution.adid : `Adjust adid not available. ${adblockerMessaging}`;
		var adjustWebUUID = window.Adjust.getWebUUID() ? window.Adjust.getWebUUID() : `Adjust web_uuid not available. ${adblockerMessaging}`;

		properties = Object.assign({}, eventMetaData, properties);
		var transactionValue = parseInt(properties.transaction_value, 10) / 100;

		properties.adjust_adid = adjustAdid;
		properties.adjust_web_uuid = adjustWebUUID;
		properties.adjust_loaded = adjustLoaded;
		properties.web_build_version = document.getElementById('build').value;
		properties.revenue = properties.transaction_value; // Params for Bing Ads

		if (optimizelyId && window.optimizelyClientInstance && typeof window.optimizelyClientInstance.track === 'function') {
			window.optimizelyClientInstance.track(event, optimizelyId, {}, properties);
		}

		trackAdjustEvent(event, null, null, properties.currency, transactionValue.toString());

		window.analytics.track(event, properties, getAnalyticsOptions(event), callback);
	}

	// Track trial signup/payment submission via Bing Ads
	window.uetq = window.uetq || [];
	window.uetq.push('event', 'Completed Registration', {
		'event_category': 'Registration',
		'event_label': 'Registration',
		'event_value': '1'
	});

	// Track trial signup/payment submission via Pinterest Tag
	pintrk('track', 'Checkout');
}

function trackLink(element, event, properties, useOldEventMetaData) {
	if (window.analytics && typeof window.analytics.trackLink === 'function') {
		var metaData = useOldEventMetaData ? {
			app: 'Growth',
			release: VERSION
		} : eventMetaData;
		var adjustLoaded = typeof window.Adjust === 'object' ? true : false;
		var adblockerMessaging = adjustLoaded ? 'Potential Ad Blocker' : '';
		var adjustAttribution = window.Adjust.getAttribution();
		var adjustAdid = adjustAttribution ? adjustAttribution.adid : `Adjust adid not available. ${adblockerMessaging}`;
		var adjustWebUUID = window.Adjust.getWebUUID() ? window.Adjust.getWebUUID() : `Adjust web_uuid not available. ${adblockerMessaging}`;

		properties = Object.assign({}, metaData, properties);
		properties.adjust_adid = adjustAdid;
		properties.adjust_web_uuid = adjustWebUUID;
		properties.adjust_loaded = adjustLoaded;
		properties.web_build_version = document.getElementById('build').value;

		window.analytics.trackLink(element, event, properties, getAnalyticsOptions(event));
	}
}

export { eventMetaData, getAnalyticsOptions, identify, track, trackAdjustEvent, trackSuccessfulRegistration, trackSuccessfulTrialSignup, trackLink };
